import React, { useRef } from "react"
import PropTypes from "prop-types"
import { createStructuredSelector } from "reselect"
import { connect } from "react-redux"
import debounce from "lodash.debounce"

// components
import { SearchTextarea } from "quorumdesign"

// action creators
import { setSearchFiltersTerm } from "app/static/frontend/search-new/action-creators"

// selectors
import { selectSearchValue } from "app/static/frontend/search-new/selectors"

export const SearchFiltersTextareaFilter = (props) => {
    const searchTextareaRef = useRef(null)
    const searchInputOnKeyUp = debounce(() => {
        if (
            searchTextareaRef.current.value.length === 0 ||
            searchTextareaRef.current.value.length > 2
        ) {
            props.setSearchFiltersTerm({
                searchFilterTerm: searchTextareaRef.current.value,
                uniqueFlvId: props.uniqueFlvId,
            })
        }
    }, 250)

    return (
        <SearchTextarea
            clearButtonOnClick={() => {
                searchTextareaRef.current.value = ""
                props.setSearchFiltersTerm({
                    searchFilterTerm: "",
                    uniqueFlvId: props.uniqueFlvId,
                })
                props.closeAllFilterGroups(props.uniqueFlvId)
            }}
            dataCy="MoleculeSearchFiltersTextarea"
            isPrimary={false}
            hasBorder
            isSearchFiltersTextarea
            searchInputValue={props.searchFilterTerm}
            searchInputDefaultValue={props.searchFilterTerm}
            searchInputOnKeyDown={(event) => {
                if (event.key === "Enter") {
                    event.preventDefault()
                    if (
                        searchTextareaRef.current.value.length === 0 ||
                        searchTextareaRef.current.value.length > 2
                    ) {
                        props.setSearchFiltersTerm({
                            searchFilterTerm: searchTextareaRef.current.value,
                            uniqueFlvId: props.uniqueFlvId,
                        })
                    }
                }
            }}
            searchInputOnKeyUp={(event) => {
                event.persist()
                searchInputOnKeyUp(event)
            }}
            searchInputPlaceholder="Search filters..."
            searchTextareaRef={searchTextareaRef}
        />
    )
}
SearchFiltersTextareaFilter.propTypes = {
    closeAllFilterGroups: PropTypes.func,
    searchFilterTerm: PropTypes.string,
    setSearchFiltersTerm: PropTypes.func,
    uniqueFlvId: PropTypes.string,
}

const mapStateToProps = createStructuredSelector({
    searchFilterTerm: selectSearchValue("searchFilterTerm"),
})
const mapDispatchToProps = { setSearchFiltersTerm }
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SearchFiltersTextareaFilter)
